/**
 * A figure with its percent sign set small — the figures bands' way of writing
 * a unit (`<b>۱۰<small>٪</small></b>`). Persian puts the sign on the left
 * («٪۱۰», see lib/percent); the isolate keeps it there inside any parent.
 */
export default function PercentFigure({ figure, isFa }: { figure: string; isFa: boolean }) {
  return isFa ? <bdi dir="ltr"><small>٪</small>{figure}</bdi> : <>{figure}<small>%</small></>;
}
